// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__5X8WV","modal":"styles_modal__1Vco6","title":"styles_title__3-qeZ"};